import * as fn from './utils'
import StephanieHero from './images/STEPHANIE_FAOLI-8.jpg'
import StephanieHero_low from './images/STEPHANIE_FAOLI-8_low.jpg'
import StephanieHeroMobile from './images/STEPHANIE_FAOLI-82.jpg'
import StephanieHeroMobile_low from './images/STEPHANIE_FAOLI-82_low.jpg'
import Stephanie2 from './images/STEPHANIE_FAOLI-44.jpg'
import Stephanie2_low from './images/STEPHANIE_FAOLI-44_low.jpg'
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom'
import { Blog } from './Blog'
import { MetaPixel } from './pixel/Meta'
import { GooglePixel } from './pixel/Google'
import GoogleIcon from '@mui/icons-material/Google';
import ProgressiveBackground from './components/ProgressiveBackground'
import { Testimonials } from './Testimonials'


function Blob(props:any){
    return(
        <svg viewBox={props.scale?"0 0 200 400":"0 0 200 200"} xmlns="http://www.w3.org/2000/svg">
            <path fill={fn.Colors.pastel} d="M47.7,-56.6C63.5,-54.2,79,-42.5,75.7,-29.9C72.5,-17.4,50.4,-4.1,40.2,8.6C29.9,21.2,31.4,33.2,26.6,46.9C21.9,60.6,11,76,-0.1,76.2C-11.2,76.4,-22.5,61.4,-37.7,51.2C-53,40.9,-72.2,35.3,-80.8,22.9C-89.3,10.6,-87.2,-8.5,-76.1,-19.2C-65.1,-29.9,-45,-32.1,-30.8,-35C-16.6,-38,-8.3,-41.6,3.8,-46.9C16,-52.1,32,-59.1,47.7,-56.6Z" transform={props.scale?"translate(100 150) scale(2)":"translate(100 100)"} />
        </svg>
    )
}

function Wave(props:any){
    return(
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill={fn.Colors.pastelLight} fillOpacity="1" d="M0,128L48,149.3C96,171,192,213,288,213.3C384,213,480,171,576,160C672,149,768,171,864,170.7C960,171,1056,149,1152,128C1248,107,1344,85,1392,74.7L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>
    )
}
const wpp_number = '5521975148921'

const handleAgendarClick = () => {
  // Meta Pixel
  if (window.fbq) {
    window.fbq('track', 'Contact', {
      content_name: 'Agendar Consulta',
      method: 'WhatsApp',
    });
  }

  // Google Pixel / GA4
  if (window.gtag) {
    window.gtag('event', 'generate_lead', {
      event_category: 'engagement',
      event_label: 'Agendar Consulta',
      method: 'WhatsApp',
    });
  }

  window.open(`https://wa.me/${wpp_number}`, '_blank');
};

const icons = [
    {icon:InstagramIcon ,link:'https://www.instagram.com/stephaniefaria.psicologa'},
    {icon:WhatsAppIcon ,link:'https://wa.me/'+wpp_number},
    {icon: GoogleIcon, link: 'https://g.co/kgs/QAKyF3h'}
]

function WppButton(props:any){
    return(
        <div style={{position:'fixed', bottom:'10px', left:props.mobile?'':'10%', right:props.mobile?'10px':'', borderRadius:'20px', backgroundColor:'#68A762', border:'1px solid #5A8A56', color:'#fff', padding:'10px 20px', display:'flex', alignItems:'center', transform:props.mobile?'':'translateX(-50%)', zIndex:"1000", cursor:'pointer'}}
        onClick={handleAgendarClick}
        >
            <div style={{marginRight:'5px'}}>
                <WhatsAppIcon/>
            </div>
            <div style={{fontWeight:'600', transform:'translateY(-2px)'}}>
                Agende sua consulta
            </div>
        </div>
    )
}

function Menu(props:any){

    const [goScroll, setGoScroll] = useState<any>({sobremim:0, atendimento:0, blog:0})


    useEffect(()=>{
        setGoScroll(props.scroll)
    },[])

    useEffect(()=>{
        setGoScroll(props.scroll)
    },[props.scroll])

    const boxShadow = `10px 10px 23px -11px rgba(0,0,0,0.1)`

    const options = [
        {
            label:'SOBRE MIM',
            id:'sobremim'
        },
        {
            label:'ATENDIMENTO',
            id:'atendimento'
        },
        {
            label:'BLOG',
            id:'blog'
        },
    ]
    return(
        <div style={{position:'absolute', top:'0', right:'0', display:'flex', alignItems:'center', width:'100%', justifyContent:props.mobile?'center':'right', backgroundColor:fn.Colors.background, padding:props.mobile?'10px 0':'10px 40px', boxShadow:boxShadow}}>
            {options.map((opt:any, index:any)=>{
                return(
                    <div key={index} style={{marginLeft:index>0&&(props.mobile?'5px':'40px')||('')}}>
                        <span style={{cursor:'pointer', fontSize:props.mobile?'14px':'20px'}} onClick={()=>{window.scrollTo({top:goScroll[opt.id], behavior:'smooth'})}}>{opt.label}</span>
                    </div>
                )
            })}
            <div style={{marginLeft:props.mobile?'5px':'40px', cursor:'pointer', borderRadius:'5px', backgroundColor:fn.Colors.light, padding:props.mobile?'5px 10px':'5px 20px', color:fn.Colors.background}} onClick={handleAgendarClick}>
                <span style={{fontSize:props.mobile?'12px':'16px', fontWeight:props.mobile&&('500')}}>AGENDAR CONSULTA</span>
            </div>
        </div>
    )
}

export function Main(props:any){

    const navigate = useNavigate()

    const [yAxis, setYAxis] = useState(0)
    
    const [goScroll, setGoScroll] = useState({sobremim:0, servicos:0, blog:0})
    const [titleTop, setTitleTop] = useState(0)

    function getTitleTop(){
        const heroBottom = document.getElementById('hero')?.getBoundingClientRect().bottom
        const titleHeight = document.getElementById('maintitle')?.clientHeight
        return(heroBottom!-titleHeight!)
    }

    useEffect(()=>{
        const elements = ['sobremim', 'blog', 'atendimento']

        let scrollPos:any = {}
        for(let a=0;a<elements.length;a++){
            if(document.getElementById(elements[a])!=undefined){
                if(props.mobile){
                scrollPos[elements[a]] = Number(document.getElementById(elements[a])?.getBoundingClientRect().top)-10
                } else {
                scrollPos[elements[a]] = Number(document.getElementById(elements[a])?.getBoundingClientRect().top)-50
                }
            }
        }
        setGoScroll(scrollPos)
        window.addEventListener('scroll', ()=>{handleScroll()})
    },[])

    useEffect(()=>{
        setTitleTop(getTitleTop())
    },[props.mobile])

    function handleScroll(){
        setYAxis(window.pageYOffset)
    }

    return(
        <div style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
            <MetaPixel/>
            <GooglePixel/>
            <WppButton mobile={props.mobile}/>
            <div id='hero' style={{height:props.mobile?'80vh':'100vh',display:'inline-block',
                // textShadow:'4px 4px 3px rgba(0,0,0,0.25)',
                color:'#4e3325'}}>
                <ProgressiveBackground style={{position:'absolute', width:'100%', height:props.mobile?'80%':'100%', backgroundSize:props.mobile?'190%':'cover', backgroundPositionX:props.mobile?'35%':'', zIndex:'-1', right:'0'}}
                lowRes={window.innerHeight > window.innerWidth?StephanieHeroMobile_low:StephanieHero_low}
                highRes={window.innerHeight > window.innerWidth?StephanieHeroMobile:StephanieHero}
                />
                {/* <div style={{position:'absolute', backgroundImage:props.mobile?`url(`+StephanieHeroMobile+`)`:`url(`+StephanieHero+`)`, width:'100%', height:props.mobile?'80%':'100%', backgroundSize:props.mobile?'190%':'cover', backgroundPositionX:props.mobile?'35%':'', zIndex:'-1', right:'0'}}/> */}
                {!props.mobile&&(<div style={{position:'absolute', background:'linear-gradient(90deg,rgba(251, 241, 236, 0.5) 0%, rgba(251, 241, 236, 0.3) 80%, rgba(251, 241, 236, 0) 100%)', width:'45%', height:'100%', left:'0'}}/>)}
                {props.mobile&&(<div style={{position:'absolute', background:'linear-gradient(0deg,rgba(251, 241, 236, 1) 0%, rgba(251, 241, 236, 0.5) 80%, rgba(251, 241, 236, 0) 100%)', width:'100%', height:'20%', left:'0', bottom:'20%'}}/>)}
                {!props.mobile&&(<div className={yAxis==0?'show':'hide'} style={{color:fn.Colors.background, position:'absolute', top:'100%', transform:'translateY(-100%) translateX(-50%)'}}><ArrowForwardIosIcon style={{transform:'rotate(90deg)',fontSize:'60px'}}/></div>)}
                <Menu mobile={props.mobile} scroll={goScroll}/>
                <div id='maintitle' style={{fontFamily: fn.Fonts.title, textAlign:'center', display:'inline-block', position:'absolute',top:props.mobile?titleTop:'50%', left:props.mobile?'0%':'8%'}}>
                    <div style={{fontWeight:'600', fontSize:props.mobile?'55px':'60px', lineHeight:props.mobile?'75px':'50px', letterSpacing:'3px'}}>
                        Stephanie Faria
                    </div>
                    <div style={{fontFamily:fn.Fonts.primary,fontWeight:'600', fontSize:props.mobile?'20px':'30px', lineHeight:'22px'}}>
                        Psicóloga<br/>
                        <span style={{fontSize:props.mobile?'15px':'20px',fontWeight:props.mobile?'600':'400',color:props.mobile?'':'#9c684e'}}>CRP 05/81246</span>
                    </div>
                </div>
            </div>

            <div style={{width:props.mobile?'94%':'70%', margin:props.mobile?'':'0'}}>
                <div id='atendimento' style={{height:props.mobile?'auto':'30%',boxSizing:'border-box', display:'flex',flexDirection:'column', alignItems:'center', marginTop:'50px'}}>
                    <div style={{fontWeight:'600', fontFamily:fn.Fonts.subtitle, fontSize:props.mobile?'30px':'35px'}}>
                        Atendimento Psicológico Individual
                    </div>
                    <div style={{fontWeight:'400', fontFamily:fn.Fonts.primary, fontSize:'18px', marginTop:'10px'}}>
                        Ofereço atendimentos psicológicos individuais, online, voltados para adolescentes e adultos. Atendo demandas como:
                    </div>
                    <div style={{boxSizing:'border-box',fontFamily:fn.Fonts.primary, marginTop:'10px',display:'flex', flexDirection:props.mobile?'column':'row'}}>
                        <div style={{width:props.mobile?'100%':'50%', display:'flex', flexDirection:'column', alignItems:'left'}}>
                            <div style={{display:'flex', flexDirection:'column', borderRadius:'8px', border:'2px solid '+fn.Colors.pastel, margin:'5px', padding:'7px' }}>
                                <div style={{fontWeight:'600'}}>
                                    Ansiedade
                                </div>
                                <div>
                                    Você sente que sua mente está sempre acelerada e não consegue relaxar? Vamos juntas(os) encontrar formas de aliviar essas preocupações e viver com mais tranquilidade
                                </div>
                            </div>
                            <div style={{display:'flex', flexDirection:'column', borderRadius:'8px', border:'2px solid '+fn.Colors.pastel, margin:'5px', padding:'7px' }}>
                                <div style={{fontWeight:'600'}}>
                                    Depressão
                                </div>
                                <div>
                                    Está difícil encontrar motivação e prazer nas coisas que antes gostava? A terapia pode ser um espaço seguro para cuidar da sua dor e redescobrir a esperança.
                                </div>
                            </div>
                            <div style={{display:'flex', flexDirection:'column', borderRadius:'8px', border:'2px solid '+fn.Colors.pastel, margin:'5px', padding:'7px' }}>
                                <div style={{fontWeight:'600'}}>
                                        Transtorno do Pânico
                                </div>
                                <div>
                                    As crises de pânico estão interferindo na sua rotina? Aqui, você pode aprender a compreender os sinais do seu corpo e recuperar o controle da sua vida.
                                </div>
                            </div>
                        </div>
                        <div style={{width:props.mobile?'100%':'50%', display:'flex', flexDirection:'column', alignItems:'left'}}>
                            <div style={{display:'flex', flexDirection:'column', borderRadius:'8px', border:'2px solid '+fn.Colors.pastel, margin:'5px', padding:'7px' }}>
                                <div style={{fontWeight:'600'}}>
                                    Estresse
                                </div>
                                <div>
                                    O cansaço e a sobrecarga parecem não ter fim? Juntas(os), podemos identificar o que está pesando e buscar estratégias para viver com mais leveza.
                                </div>
                            </div>
                            <div style={{display:'flex', flexDirection:'column', borderRadius:'8px', border:'2px solid '+fn.Colors.pastel, margin:'5px', padding:'7px' }}>
                                <div style={{fontWeight:'600'}}>
                                    Baixa Auto-Estima
                                </div>
                                <div>
                                    Você tem dificuldade em reconhecer suas qualidades e valor? A terapia é um caminho para fortalecer sua autoconfiança e se olhar com mais gentileza.
                                </div>
                            </div>
                            <div style={{display:'flex', flexDirection:'column', borderRadius:'8px', border:'2px solid '+fn.Colors.pastel, margin:'5px', padding:'7px' }}>

                                <div style={{fontWeight:'600'}}>
                                    Dificuldades em Relacionamentos
                                </div>
                                <div>
                                    Os vínculos afetivos têm gerado conflitos ou sofrimento? A psicoterapia pode ajudar a melhorar a comunicação e construir relações mais saudáveis.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{fontWeight:'400', fontFamily:fn.Fonts.primary, fontSize:'18px', marginTop:'10px'}}>
                        Além dessas, estou disponível para acolher outras questões emocionais e psicológicas que impactem o bem-estar e a qualidade de vida.
                    </div>
                    <div style={{backgroundColor:fn.Colors.light, padding:'10px 25px', display:'flex', color:"#fff", width:props.mobile&&('fitContent'), alignSelf:props.mobile&&('center'), fontFamily:fn.Fonts.primary, fontWeight:'600', cursor:'pointer', fontSize:'16px', marginTop:'30px', alignItems:'center'}} onClick={handleAgendarClick}>
                        <div>
                            <WhatsAppIcon style={{padding:'0px', margin:'0px', transform:'translateY(2px)'}}/>
                        </div>
                        <div style={{marginLeft:'10px', fontSize:'18px'}}>
                            Vamos Conversar?
                        </div>
                    </div>
                </div>

                <div style={{width:'100vw', height:'100vw', position:'absolute', zIndex:'-5', left:'0', transform:props.mobile?'15%':"translateY(-28%)"}}>
                    <Blob scale={props.mobile}/>
                </div>
                <div style={{height:props.mobile?'':'70%',boxSizing:'border-box', display:'flex', justifyContent:'center', margin:props.mobile?'50px 0 0':''}}>
                    {!props.mobile&&window.innerWidth>1215&&(<div style={{width:'50%', display:'flex',justifyContent:'left', alignItems:'center'}}>
                        <ProgressiveBackground
                        style={{width:'400px', height:'600px', backgroundSize:'cover'}}
                        lowRes={Stephanie2_low}
                        highRes={Stephanie2}
                        />
                        {/* <div style={{backgroundImage:`url(`+Stephanie2+`)`, width:'400px', height:'600px', backgroundSize:'cover'}}> */}

                        {/* </div> */}
                    </div>)}
                    <div id='sobremim' style={{width:props.mobile?'100%':window.innerWidth>1215?'50%':'100%', display:'flex',justifyContent:props.mobile?'left':'right', alignItems:'center', marginTop:props.mobile?'':'50px'}}>
                        <div style={{width:props.mobile?'100%':window.innerWidth>1215?'500px':'100%', fontFamily:fn.Fonts.primary, display:props.mobile?'flex':'', flexDirection:'column'}}>
                            <div style={{fontWeight:'600', fontFamily:fn.Fonts.subtitle, fontSize:props.mobile?'30px':'35px'}}>
                                Sobre mim
                            </div>
                            <div style={{marginTop:'30px', fontSize:'18px'}}>
                            Sou formada em Psicologia pela Universidade Veiga de Almeida e pós-graduada em Terapia Cognitivo-Comportamental (TCC) pela PUC-RS. Escolhi a TCC como abordagem de trabalho por ser baseada em evidências científicas e focada em compreender como nossos pensamentos influenciam nossos sentimentos e comportamentos.<br/><br/>
                            Meu objetivo é oferecer um espaço de escuta acolhedora, segura e colaborativa, ajudando cada pessoa a desenvolver estratégias mais saudáveis para lidar com suas dificuldades emocionais e promover qualidade de vida. Acredito que cada trajetória é única, e por isso, construo o processo terapêutico com respeito, empatia e compromisso com a singularidade de quem me procura.<br/><br/>
                            Acredito na importância de cuidar da saúde mental de forma ampla, com atenção às diversas questões que impactam nosso bem-estar emocional. Atendo pessoas com diferentes histórias e necessidades, sendo ansiedade, autoestima, relacionamentos, depressão, estresse e autoconhecimento algumas das principais demandas que trabalho na clínica. Essas são áreas que afetam profundamente a maneira como nos sentimos, nos percebemos e nos relacionamos com o mundo — e é justamente por isso que merecem um espaço de escuta qualificada e transformação.
                            </div>
                            <div style={{backgroundColor:fn.Colors.light, padding:'10px 25px', display:'inline-flex', alignItems:'center', color:"#fff", width:'fitContent', alignSelf:props.mobile&&('center'), fontFamily:fn.Fonts.primary, fontWeight:'600', cursor:'pointer', fontSize:'16px', marginTop:'30px'}} onClick={handleAgendarClick}>
                                <div style={{marginRight:'10px'}}>
                                    Agende sua sessão e vamos dar esse passo juntos.
                                </div>
                                <div>
                                    <WhatsAppIcon style={{padding:'0px', margin:'0px', transform:'translateY(2px)'}}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>

            <div id='testimonials' style={{width:'100%', display:'flex'}}>
                <Testimonials mobile={props.mobile}/>
            </div>

            <div id='blog' style={{display:'flex', width:'100%', padding:'0', flexDirection:'column', alignItems:'center', marginTop:"50px"}}>
                    <div style={{height:'100px', width:'100%', position:'absolute', zIndex:'-1', transform:'translateY(calc(100vw*-0.15))'}}>
                        <Wave/>
                    </div>
                    <div style={{marginTop:props.mobile?'0px':'0px', width:'100%', backgroundColor:fn.Colors.pastelLight}}>
                        <Blog access={0} mobile={props.mobile}/>
                    </div>
            </div>
            
            <div style={{backgroundColor:fn.Colors.foreground, width:'100%', display:'flex', justifyContent:'center'}}>
                <div style={{width:props.mobile?'90%':'70%', display:'flex', justifyContent:'center', padding:props.mobile?'50px 0 70px':'50px 0', flexDirection:props.mobile&&('column')}}>
                    <div style={{width:props.mobile?'100%':'50%'}}>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d59788.48905301334!2d-43.40749396529372!3d-23.002351190599374!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9bda4a27b6fe5d%3A0x63c3f6d1d89e0f4e!2sBarra%20da%20Tijuca%2C%20Rio%20de%20Janeiro%20-%20RJ!5e0!3m2!1spt-BR!2sbr!4v1745378287128!5m2!1spt-BR!2sbr" width={props.mobile?'100%':"400"} height="200" loading="lazy" style={{border:'none', borderRadius:'5px'}}></iframe>
                    </div>
                    <div style={{width:props.mobile?'100%':'50%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:props.mobile&&('40px')}}>
                        {icons.map((icon:any, index:any)=>{
                            const IconComponent = icon.icon
                            return(
                                <div key={index} style={{color:fn.Colors.background, marginLeft:index>0?'20px':'0'}}>
                                    <IconComponent style={{fontSize:'40px', cursor:'pointer'}} onClick={()=>{window.open(icon.link,'_blank')}}/>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}